// constants.js
export const commonTitleStyle = {
    fontWeight: "bold",
    fontSize: "2.5rem",
    color: "#c4a96a",
    textTransform: "uppercase",
    textAlign: "center",
    marginBottom: "40px", // Consistent bottom spacing
    paddingTop: "120px",  // Uniform distance from navbar
};
